import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ListItemLineDirective } from './list-item-line.directive';

@NgModule({
  declarations: [
    ListItemLineDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ListItemLineDirective
  ]
})
export class ListItemLineModule { }
